import { useMount } from 'ahooks';
import { Layout } from 'antd';
import { useAppDispatch } from 'app/hooks';
import { NotFound } from 'features/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import {
  AccountAdmin,
  CtAdmin,
  EqptAdmin,
  MarkupAdmin,
  MatAdmin,
  NetworkAdmin,
  OrgAdmin,
  ParcelAdmin,
  ResellerCertificateAdmin,
  ResourcesAdmin,
  ShippingAdmin,
  SkuAdmin,
  SVCAdmin,
  TfAdmin,
  CSRAdmin,
  SLAAdmin,
  FileAdmin,
} from './components';
import UnitPrice from './components/SkuAdmin/UnitPrice/UnitPrice';
import { EqptFilterForm } from './components/EqptAdmin/EqptFilterForm';
import { EqptHeader } from './components/EqptAdmin/EqptHeader';
import EqptTfAdmin from './components/EqptAdmin/EqptTfAdminContainer';
import { MatFilterForm } from './components/MatAdmin/MatFilterForm';
import { MatHeader } from './components/MatAdmin/MatHeader';
import { ParcelFilterForm } from './components/ParcelAdmin/ParcelFilterForm';
import { ParcelHeader } from './components/ParcelAdmin/ParcelHeader';
import { SkuFilterForm } from './components/SkuAdmin/SkuFilterForm';
import { SkuHeader } from './components/SkuAdmin/SkuHeader';
import { SVCFilterForm } from './components/SVCAdmin/SVCFilterForm';
import { SVCHeader } from './components/SVCAdmin/SVCHeader';
import { FilterLayout } from './FilterLayout';
import PlatformHeader from './PlatformHeader';
import PlatformMenu from './PlatformMenu';
import PlatformSider from './PlatformSider';

const { Content } = Layout;

const PlatformLayout = () => {
  const { path } = useRouteMatch();
  const dispatch = useAppDispatch();

  useMount(() => {
    dispatch.org.getOrgs();
  });

  return (
    <Layout className="platform-layout">
      <PlatformHeader />
      <PlatformSider />
      <PlatformMenu />
      <Content className="platform-content">
        <Switch>
          <Route path={`${path}/eqpt/:eqptid/tf`} exact>
            <EqptTfAdmin />
          </Route>
          <Route path={`${path}/org/:orgid/ct`} exact>
            <CtAdmin />
          </Route>
          <Route path={`${path}/org`}>
            <OrgAdmin />
          </Route>
          <Route path={`${path}/sku`} exact={true}>
            <FilterLayout
              filterForm={<SkuFilterForm />}
              header={<SkuHeader />}
              modelName="sku"
            >
              <SkuAdmin />
            </FilterLayout>
          </Route>
          <Route path={`${path}/sku/unit-price`} exact={true}>
            <UnitPrice />
          </Route>
          <Route path={`${path}/eqpt`}>
            <FilterLayout
              filterForm={<EqptFilterForm />}
              header={<EqptHeader />}
              modelName="eqpt"
            >
              <EqptAdmin />
            </FilterLayout>
          </Route>
          <Route path={`${path}/material`}>
            <FilterLayout
              filterForm={<MatFilterForm />}
              header={<MatHeader />}
              modelName="mat"
            >
              <MatAdmin />
            </FilterLayout>
          </Route>
          <Route path={`${path}/markup`}>
            <MarkupAdmin />
          </Route>
          <Route path={`${path}/network`}>
            <NetworkAdmin />
          </Route>
          <Route path={`${path}/parcel`}>
            <FilterLayout
              filterForm={<ParcelFilterForm />}
              header={<ParcelHeader />}
              modelName="parcel"
            >
              <ParcelAdmin />
            </FilterLayout>
          </Route>
          <Route path={`${path}/user-account`}>
            <AccountAdmin />
          </Route>
          <Route path={`${path}/shipping`}>
            <ShippingAdmin />
          </Route>
          <Route path={`${path}/svc`}>
            <FilterLayout
              filterForm={<SVCFilterForm />}
              header={<SVCHeader />}
              modelName="svc"
            >
              <SVCAdmin />
            </FilterLayout>
          </Route>
          <Route path={`${path}/tf`}>
            <TfAdmin />
          </Route>
          <Route path={`${path}/resources`}>
            <ResourcesAdmin />
          </Route>
          <Route path={`${path}/CSR`}>
            <CSRAdmin />
          </Route>
          <Route path={`${path}/resellerCertificate`}>
            <ResellerCertificateAdmin />
          </Route>
          <Route path={`${path}/SLA`}>
            <SLAAdmin />
          </Route>
          <Route path={`${path}/file`}>
            <FileAdmin />
          </Route>
          <Route component={NotFound} />
        </Switch>
      </Content>
    </Layout>
  );
};

export default PlatformLayout;
